import React, {FC, useMemo, useState} from "react";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

type componentProps = {
  style?:React.CSSProperties | CSS.Properties,
  className?:string,
  color?:string,
  backgroundColor?:string,
  children?:React.ReactNode, // | React.ReactElement<any> | React.CSSProperties
} & {[key:string]:any}; // string | boolean | number | React.ReactNode

const {$} = window;

const SpanE:FC<componentProps> = ({...props}) => {
  const [theme, setTheme] = useState($("html").attr("data-theme"));

  const styl = useMemo<React.CSSProperties | CSS.Properties>(() => {
    const est:React.CSSProperties | CSS.Properties = {...props.style};
    let clr:string; const allc = (props.color || "").split("|"); if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    if (!est?.color && clr) { est.color = clr }
    let bclr:string; const allb = (props.backgroundColor || "").split("|"); if (allb.length > 1) { bclr = (theme === "dark" ? allb[1] : allb[0]) } else { bclr = allb[0] }
    if (!est?.backgroundColor && bclr) { est.backgroundColor = bclr }
    return est;
  }, [props, theme]);

  // const Nstyle = (props.style ? {...props.style} : undefined);
  return (
    <span {...props} className={props.className} style={styl} >{props?.children}</span>
  );
};

export default SpanE;
